module.exports = __webpack_public_path__ + "img/time-looking-left.73701c32.jpg";